if (!customElements.get('currency-selector')) {
  customElements.define(
    'currency-selector',
    class CurrencySelector extends HTMLElement {
      constructor() {
        super();
        this.rates = []
        this.elements = {
          select: this.querySelector('.currency__select'),
        };
        this.currencySymbol = {
          USD: '$',
          CAD: 'CAN$',
          EUR: '€',
          GBP: '£',
        }
        this.addEventListener('change', this.changeCurrency.bind(this));
      }

      connectedCallback() {
        // Fetch currency data
        fetch('https://www.eyce.com/cdn/s/javascripts/currencies.js')
        .then(response => response.text())
        .then(jsCode => {
          const script = document.createElement('script');
          script.textContent = jsCode;
          document.head.appendChild(script);
          this.elements.select.classList.remove('hidden')
          this.init()
        })
      }

      init () {
        if (localStorage.getItem('currencySelected')) {
          const currencyFromLocalStorage = localStorage.getItem('currencySelected')
          this.updateSelectValue(currencyFromLocalStorage)
          this.updatePriceToAllPrices(currencyFromLocalStorage)
          window.siteCurrency = {
            code: currencyFromLocalStorage,
            symbol: this.currencySymbol[currencyFromLocalStorage]
          }
        } else {
          this.updateSelectValue('USD')
          this.updatePriceToAllPrices('USD')
          window.siteCurrency = {
            code: 'USD',
            symbol: this.currencySymbol.USD
          }
        }
      }
      
      changeCurrency () {
        const newCurrency = this.elements.select.value
        localStorage.setItem('currencySelected', newCurrency)
        this.updatePriceToAllPrices(newCurrency)
      }

      updateSelectValue (currency) {
        this.elements.select.value = currency
      }

      updatePriceToAllPrices (currency) {
        const priceElements = document.querySelectorAll('[data-usd-price]');
        priceElements.forEach(priceEl => {
          // priceEl.setAttribute('data-currency', currency)
          const usdPrice = priceEl.getAttribute('data-usd-price')
          if(currency === 'USD') {
            priceEl.textContent = '$' + usdPrice
          } else {
            priceEl.textContent = this.currencySymbol[currency] + Currency.convert(usdPrice, 'USD', currency).toFixed(2)
          }
        })
      }
    }
  )
}